interface StarsProps {
  value: number;
  size?: 'sm' | 'md';
}

export default function Stars({ value, size = 'sm' }: StarsProps) {
  const dim = size === 'md' ? 'text-lg w-5 h-5' : 'text-base w-4 h-4';
  const rounded = Math.round(value);
  return (
    <span className="inline-flex items-center gap-0.5" aria-label={`Note ${value} sur 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <i
          key={i}
          className={`${i <= rounded ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'} ${dim} flex items-center justify-center`}
        />
      ))}
    </span>
  );
}